import { render, staticRenderFns } from "./DevCardKS1.vue?vue&type=template&id=4788aa90&scoped=true"
import script from "./DevCardKS1.vue?vue&type=script&lang=js"
export * from "./DevCardKS1.vue?vue&type=script&lang=js"
import style0 from "./DevCardKS1.vue?vue&type=style&index=0&id=4788aa90&prod&lang=css"
import style1 from "./DevCardKS1.vue?vue&type=style&index=1&id=4788aa90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4788aa90",
  null
  
)

export default component.exports